import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { FolderViewWrapper } from "../../../src/taskpane/components/helpers/folderViewWrapper";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Rename(selectedItems: any[], waitFor: boolean, setShowRenameDialog: (showRenameDialog: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);
    
    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
    const siteInfo = useSelector((state: RootState) => state.tenantInfo.sites);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const tenantDisableFileRename = useSelector((state: RootState) => state.tenantInfo?.disableFileRename);
    
    const [menuItem_Rename, setMenuItem_Rename] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (!tenantDisableFileRename && selectedItems?.length === 1 && selectedItems[0]?.EffectiveBasePermissions?.canDeleteListItem && currentDirectory.type !== ComponentTypes.SharePointList) {
            var folderViewWrapper = new FolderViewWrapper(siteInfo, currentDirectory);
            const canViewFolder = folderViewWrapper.canViewFolder();

            if (canViewFolder || selectedItems[0].FSObjType === '0') {
                setMenuItem_Rename(
                    {
                        key: "rename",
                        disabled: waitFor === true || isBusySaving === true,
                        text: `${languageStrings.RenameOnly}`,
                        iconProps: { iconName: "Rename" },
                        onClick: () => {
                          setShowRenameDialog(true);
                        }
                    }
                )
            } else {
                setMenuItem_Rename(null)
            }
        } else {
            setMenuItem_Rename(null);
        }
    }, [selectedItems, waitFor, siteInfo, currentDirectory, tenantDisableFileRename]);
    
    return {
        menuItem_Rename
    }

}